export default __webpack_public_path__ + "static/media/mnak.03f52c92.png";